export const ELEMENT_TYPES = {
  FIELD: 0,
  SUBMITTER: 1,
  PAGE: 2,
  SUBMISSION: 3,
  PRIORITY: 4,
  SLA: 5,
};
